const PAYMENT_OPTIONS = [
  { value: "creditCard", label: "Credit Card (3.5% processing fee)" },
  { value: "checkACH", label: "Check/ACH - payable to Arett Sales" },
  { value: "advertisingFund", label: "Deduct from Arett approved Advertising Fund" },
];

const PaymentSection = ({
  title = "Payment Will Be Made By:",
  paymentMethod = "",
  onPaymentMethodChange,
  invoiceAddressText = "",
  onAddressChange,
}) => (
  <div className="payment-section">
    <div className="payment-title">{title}</div>
    <div className="radio-group" style={{ marginBottom: 14 }}>
      {PAYMENT_OPTIONS.map(({ value, label }) => (
        <label className="custom-radio" key={value}>
          <input
            type="radio"
            name="paymentMethod"
            value={value}
            checked={paymentMethod === value}
            onChange={(e) => onPaymentMethodChange && onPaymentMethodChange(e.target.value)}
          />
          <span>{label}</span>
        </label>
      ))}
    </div>
    <div className="section-divider" />
    <p className="text-small mb-8">Invoice will be mailed or emailed for payment to be processed. Enter your address or email in the space below:</p>
    <textarea
      className="form-textarea"
      rows={3}
      placeholder="Mailing/email address for invoice..."
      value={invoiceAddressText}
      onChange={(e) => onAddressChange && onAddressChange(e.target.value)}
    />
  </div>
);

export default PaymentSection;
